import CollapseButton from './CollapseButton';
export default CollapseButton;